import { render, staticRenderFns } from "./MoreHorizontal.vue?vue&type=template&id=729fa2bb&"
import script from "./MoreHorizontal.vue?vue&type=script&lang=js&"
export * from "./MoreHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports